import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import siteStyle from 'utils/siteStyle';

const Text = ({ variant, children }) => {
  const component = useMemo(() => {
    let tag = null;
    const style = {};
    switch (variant) {
      case 'h3':
        style.common = 'text-6 leading-6 -tracking-0.2 text-dark md:text-8 md:leading-8 md:-tracking-0.3';
        // style.bt = "font-korolav font-bold uppercase"
        style.foh = 'font-rajdhani font-bold';
        style.default = 'font-primary font-black';
        tag = (
          <h3 className={siteStyle(style)}>
            {children}
          </h3>
        );
        break;
      default:
        tag = <p>{children}</p>;
    }
    return tag;
  }, [variant, children]);

  return component;
};

Text.defaultProps = {
  variant: 'p',
};

Text.propTypes = {
  variant: PropTypes.string,
};

export default Text;
